import styles from './Footer.module.scss';
import * as React from 'react';

// Canonical "Do Not Sell or Share" page is hosted on ping.com — this app only
// links out to it.
const DO_NOT_SELL_URL = 'https://ping.com/en-us/legal/do-not-sell-or-share';

interface FooterProps {
  footerContent: {
    copyright?: string;
    privacyPolicyLink?: string;
    privacyPolicy?: string;
    privacySettings?: string;
    doNotSell?: string;
    doNotSellLink?: string;
    termsOfUseLink?: string;
    termsOfUse?: string;
  };
}

const Footer: React.FC<FooterProps> = ({ footerContent }) => {
  const content = footerContent;
  // This app's locale is the LANGUAGE toggle, so region must come from OneTrust
  // geolocation (async — poll until ready). null = not resolved yet; default is
  // hide-until-confirmed-US.
  const [isUSRegion, setIsUSRegion] = React.useState<boolean | null>(null);

  React.useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    let cancelled = false;
    const resolveRegion = (): boolean => {
      const country = window.OneTrust?.getGeolocationData()?.country;
      if (!country) {
        return false;
      }
      if (!cancelled) {
        setIsUSRegion(country.toLowerCase() === 'us');
      }
      return true;
    };
    if (resolveRegion()) {
      return;
    }
    const interval = setInterval(() => {
      if (resolveRegion()) {
        clearInterval(interval);
      }
    }, 200);
    const timeout = setTimeout(() => clearInterval(interval), 10000);
    return () => {
      cancelled = true;
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.copyright}>
          {`©${new Date().getFullYear()} ${content.copyright}`}
        </div>
        <div className={styles.links}>
          {content?.privacyPolicyLink &&
            content?.privacyPolicy && (
              <a href={content.privacyPolicyLink} className={styles.linkButton} target="_blank" rel="noopener noreferrer">
                {content.privacyPolicy}
              </a>
            )}
          {/* "Your Privacy Choices" — always shown, opens the OneTrust drawer. */}
          {content?.privacySettings && (
            <button
              className={styles.linkButton}
              type="button"
              onClick={() => window.OneTrust?.ToggleInfoDisplay()}
            >
              {content.privacySettings}
            </button>
          )}
          {/* "Do Not Sell or Share" — US visitors only, links to ping.com. */}
          {isUSRegion && content?.doNotSell && (
            <a
              href={DO_NOT_SELL_URL}
              className={styles.linkButton}
              target="_blank"
              rel="noopener noreferrer"
            >
              {content.doNotSell}
            </a>
          )}
          {content?.termsOfUseLink && content?.termsOfUse && (
            <a href={content.termsOfUseLink} className={styles.linkButton} target="_blank" rel="noopener noreferrer">
              {content.termsOfUse}
            </a>
          )}
        </div>
      </div>
    </footer>
  );
}

export default Footer;